import _ from 'lodash';
import moment from 'moment';
import React, {PropTypes} from 'react';
import {
  DatePicker,
  Dialog,
  FlatButton,
  FontIcon,
  TextField
} from 'material-ui';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userTaskActions from '../actions/user-task';
import * as taskActions from '../actions/task';
import MemberRow from './MemberRow';
import HiddenUsers from './HiddenUsers';
import '../styles/members.scss';

const initialState = () => {
  return {
    firstDay: moment().startOf('month'),
    openDialog: false,
    selectedTask: null,
    taskName: '',
    hoursADay: 1,
    startAt: null,
    endAt: null,
    taskNameHasError: false,
    hoursADayHasError: false,
    startAtHasError: false,
    endAtHasError: false,
    headerRowStyle: null
  };
};

const initialStateWithoutFirstDay = () => {
  return {
    openDialog: false,
    selectedTask: null,
    taskName: '',
    hoursADay: 1,
    startAt: null,
    endAt: null,
    taskNameHasError: false,
    hoursADayHasError: false,
    startAtHasError: false,
    endAtHasError: false
  };
};

class MembersPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState();
    this.scrollContentOffset = 0;
    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.handleTaskChange = this.handleTaskChange.bind(this);
    this.handleHoursChange = this.handleHoursChange.bind(this);
    this.handleStartAtChange = this.handleStartAtChange.bind(this);
    this.handleEndAtChange = this.handleEndAtChange.bind(this);
    this.handleTaskRowTouchTap = this.handleTaskRowTouchTap.bind(this);
    this.handleScroll = _.throttle((() => {
      if (window.pageYOffset >= this.scrollContentOffset) {
        if (this.state.headerRowStyle === null) {
          this.setState({headerRowStyle: {
            background: '#fff',
            paddingTop: '1.618rem',
            position: 'fixed',
            top: 0,
            width: 'calc(100% - 3.236rem)',
            zIndex: 12
          }});
        }
      } else {
        if (this.state.headerRowStyle !== null) {
          this.setState({headerRowStyle: null});
        }
      }
    }).bind(this), 100);
  }

  componentDidMount() {
    const {firstDay} = this.state;
    this.props.userTaskActions.fetchUserTasks(
      firstDay,
      moment(firstDay.toDate()).endOf('month')
    );
    this.props.userTaskActions.restoreHiddenUids();
    const interval = setInterval((() => {
      if (this.refs.headerRow) {
        const el = this.refs.headerRow;
        this.scrollContentOffset = el.getBoundingClientRect().top + window.pageYOffset;
        window.addEventListener('scroll', this.handleScroll);
        clearInterval(interval);
      }
    }).bind(this), 100);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handlePrev() {
    //TODO: fetchUserTasks
    let newFirstDay = moment(this.state.firstDay.toDate()).subtract(1, 'month');
    this.setState({
      firstDay: newFirstDay
    });
    this.props.userTaskActions.fetchUserTasks(
      newFirstDay,
      moment(newFirstDay.toDate()).endOf('month')
    );
  }

  handleNext() {
    //TODO: fetchUserTasks
    let newFirstDay = moment(this.state.firstDay.toDate()).add(1, 'month');
    this.setState({
      firstDay: newFirstDay
    });
    this.props.userTaskActions.fetchUserTasks(
      newFirstDay,
      moment(newFirstDay.toDate()).endOf('month')
    );
  }

  handleSave() {
    const {
      firstDay,
      selectedTask,
      taskName,
      hoursADay,
      startAt,
      endAt
    } = this.state;
    this.props.taskActions.updateTask(selectedTask.key, {
      name: taskName,
      hours: hoursADay,
      startAt: startAt,
      endAt: endAt
    }).then(() => {
      this.setState(initialStateWithoutFirstDay());
      this.props.userTaskActions.fetchMyUserTasks(
        firstDay,
        moment(firstDay.toDate()).endOf('month')
      );
    });
  }

  handleDelete() {
    const {firstDay, selectedTask} = this.state;
    if (confirm('Are you sure?')) {
      this.props.taskActions.deleteTask(
        selectedTask.key
      ).then(() => {
        this.setState(initialStateWithoutFirstDay());
        this.props.userTaskActions.fetchMyUserTasks(
          firstDay,
          moment(firstDay.toDate()).endOf('month')
        );
      });
    }
  }

  handleCloseDialog() {
    this.setState(initialStateWithoutFirstDay());
  }

  handleTaskChange(event) {
    this.setState({taskName: event.target.value});
  }

  handleHoursChange(event) {
    this.setState({hoursADay: event.target.value});
  }

  handleStartAtChange(event, date) {
    this.setState({startAt: date});
  }

  handleEndAtChange(event, date) {
    this.setState({endAt: date});
  }

  handleTaskRowTouchTap(task) {
    this.setState({
      selectedTask: task,
      taskName: task.name,
      hoursADay: task.hours,
      startAt: moment(task.startAt).toDate(),
      endAt: moment(task.endAt).toDate(),
      openDialog: true
    });
  }

  render() {
    const {
      firstDay,
      openDialog,
      taskName,
      hoursADay,
      startAt,
      endAt,
      taskNameHasError,
      hoursADayHasError,
      startAtHasError,
      endAtHasError,
      headerRowStyle
    } = this.state;
    const {users, hiddenUids} = this.props;
    const lastDay = moment(firstDay.toDate()).endOf('month');
    const iconStyles = {
      fontSize: '1.2rem',
      verticalAlign: 'bottom'
    };
    if (users.length <= 0) {
      return <div>There is no resources.</div>
    }

    const dialogActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleCloseDialog}
      />,
      <FlatButton
        label="Delete"
        secondary={true}
        onTouchTap={this.handleDelete}
      />,
      <FlatButton
        label="Save"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.handleSave}
      />
    ];

    let shownUsers = [], hiddenUsers = [];
    //TODO: move to actions
    _.each(users, (u) => {
      if (_.indexOf(hiddenUids, u.uid) >= 0) {
        hiddenUsers.push({
          uid: u.uid,
          name: u.name,
          avatarUrl: u.avatarUrl
        });
      } else {
        shownUsers.push(u);
      }
    });

    return (
      <div>
        <h1>Members</h1>
        <Dialog
          title="Edit Task"
          actions={dialogActions}
          modal={true}
          open={openDialog}
          onRequestClose={this.handleCloseDialog}
        >
          <form>
            <div>
              <TextField
                hintText="This field is required"
                floatingLabelText="Task Name"
                value={taskName}
                errorText={taskNameHasError ? 'You should input task name' : ''}
                onChange={this.handleTaskChange}
              />
            </div>
            <div>
              <TextField
                hintText="This field is required"
                type="number"
                floatingLabelText="Hours a day"
                value={hoursADay}
                errorText={hoursADayHasError ? 'You should input hours a day' : ''}
                onChange={this.handleHoursChange}
              />
            </div>
            <div>
              <DatePicker
                hintText="Start at"
                mode="landscape"
                value={startAt}
                errorText={startAtHasError? 'You should input start at' : ''}
                onChange={this.handleStartAtChange}
              />
            </div>
            <div>
              <DatePicker
                hintText="End at"
                mode="landscape"
                value={endAt}
                errorText={endAtHasError? 'You should input end at' : ''}
                onChange={this.handleEndAtChange}
              />
            </div>
          </form>
        </Dialog>
        <div className="member-tasks">
          <div className="row header-row" ref="headerRow" style={headerRowStyle}>
            <div className="header-col">
              <a href="javascript:void(0)" onClick={this.handlePrev}>
                <FontIcon className="material-icons" style={iconStyles}>keyboard_arrow_left</FontIcon>
              </a>
              {firstDay.format('YYYY/MM')}
              <a href="javascript:void(0)" onClick={this.handleNext}>
                <FontIcon className="material-icons" style={iconStyles}>keyboard_arrow_right</FontIcon>
              </a>
            </div>
            {_.times(lastDay.diff(firstDay, 'days') + 1, (day) => {
              return <div className={`col day-${moment(firstDay.toDate()).add(day, 'day').format('d')}`} key={day}>
                  <span>{day+1}</span>
                </div>
            })}
          </div>
          {shownUsers.map((u) => {
            return <MemberRow
                      user={u}
                      key={u.uid}
                      firstDay={firstDay}
                      lastDay={lastDay}
                      onTaskTouchTap={this.handleTaskRowTouchTap}
                    />
          })}
        </div>
        <hr/>
        <h2>Hidden Members</h2>
        <HiddenUsers users={hiddenUsers} />
      </div>
    )
  }
}

MembersPage.propTypes = {
  userTaskActions: PropTypes.object.isRequired,
  taskActions: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return {
    users: state.userTask.users,
    hiddenUids: state.userTask.hiddenUids
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userTaskActions: bindActionCreators(userTaskActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembersPage);



/** WEBPACK FOOTER **
 ** ./src/components/MembersPage.js
 **/